import { ITraveller } from "../ITraveller";

export interface IAirTraveller extends ITraveller {
    type: AirTravellerType;
    key: {
        [host: string]: string;
    };
}

export enum AirTravellerType {
    Adult = "Adult",
    Child = "Child",
    Infant = "Infant",
}